import React from "react";
import axios from "axios";
import { connect } from "react-redux";
import {
  FaMapMarkerAlt,
  FaPlus,
  FaTrashAlt,
  FaPen,
  FaStar,
} from "react-icons/fa";
import alertify from "alertifyjs";
import { Translate, I18n } from "react-redux-i18n";
import Modal from "./Modal";
import * as actions_state from "../redux/actions/stateActions";
import * as actions_address from "../redux/actions/addressActions";
import { config } from "../config";
import "./styles/ProfileAddresses.css";
import "./styles/Alertify.css";
import "./styles/AlertifyTheme.css";
import "./styles/Alertify.min.css";
import "./styles/AlertifyTheme.min.css";

const url_api = config.api.godiway;

const emptyForm = () => ({
  id: null,
  name: "",
  state_id: "",
  city_id: "",
  address1: "",
  address2: "",
  zipcode: "",
  phone: "",
});

const formFromAddress = (item) => ({
  id: item.Id,
  name: item.Name || "",
  state_id: (item.State && item.State.Id) || "",
  city_id: (item.City && item.City.Id) || "",
  address1: item.Address1 || "",
  address2: item.Address2 || "",
  zipcode: item.Zipcode || "",
  phone: item.Phone || "",
});

class ProfileAddresses extends React.Component {
  state = {
    modalOpen: false,
    editingId: null,
    form: emptyForm(),
    cities: [],
    saving: false,
  };

  async componentDidMount() {
    await this.props.LoadStates(this.props.user_id, this.props.token);
    await this.props.LoadAddresses(this.props.user_id, this.props.token);
  }

  fetchCities = async (stateId) => {
    if (!stateId) {
      this.setState({ cities: [] });
      return;
    }
    try {
      const response = await axios.get(url_api + "city", {
        params: { state_id: stateId, id: this.props.user_id },
        headers: { Authorization: `Bearer ${this.props.token}` },
      });
      if (response.data.status === "Success") {
        const body = response.data.body;
        const list = Array.isArray(body) ? body : (body && body.list) || [];
        this.setState({ cities: list });
      }
    } catch (error) {
      this.setState({ cities: [] });
    }
  };

  openCreate = () => {
    const max = this.props.max || 5;
    if ((this.props.addressList || []).length >= max) {
      alertify.warning(I18n.t("address_max"));
      return;
    }
    this.setState(
      { modalOpen: true, editingId: null, form: emptyForm(), cities: [] }
    );
  };

  openEdit = (item) => {
    const form = formFromAddress(item);
    this.setState({ modalOpen: true, editingId: item.Id, form, cities: [] });
    if (form.state_id) {
      this.fetchCities(form.state_id);
    }
  };

  closeModal = () => {
    this.setState({ modalOpen: false, saving: false });
  };

  onChangeField = (field) => (event) => {
    this.setState({ form: { ...this.state.form, [field]: event.target.value } });
  };

  onChangeState = (event) => {
    const stateId = event.target.value;
    this.setState({
      form: { ...this.state.form, state_id: stateId, city_id: "" },
    });
    this.fetchCities(stateId);
  };

  isValid = () => {
    const { form } = this.state;
    return (
      form.name.trim() &&
      form.state_id &&
      form.city_id &&
      form.address1.trim()
    );
  };

  onSubmit = async () => {
    if (!this.isValid()) {
      alertify.warning(I18n.t("address_required"));
      return;
    }

    this.setState({ saving: true });

    const { form, editingId } = this.state;
    const params = {
      address_id: editingId,
      name: form.name.trim(),
      state_id: form.state_id || null,
      city_id: form.city_id || null,
      address1: form.address1.trim(),
      address2: form.address2,
      zipcode: form.zipcode,
      phone: form.phone,
    };

    const result = editingId
      ? await this.props.UpdateAddress(this.props.user_id, this.props.token, params)
      : await this.props.CreateAddress(this.props.user_id, this.props.token, params);

    if (result && result.ok) {
      alertify.success(I18n.t("saved_succesfull"));
      this.closeModal();
    } else {
      this.setState({ saving: false });
      alertify.warning(I18n.t((result && result.error) || "try_later"));
    }
  };

  onDelete = (item) => {
    alertify.confirm(
      I18n.t("address_delete_title"),
      I18n.t("address_delete_confirm"),
      async () => {
        const result = await this.props.RemoveAddress(
          this.props.user_id,
          this.props.token,
          item.Id
        );
        if (result && result.ok) {
          alertify.success(I18n.t("saved_succesfull"));
        } else {
          alertify.warning(I18n.t("try_later"));
        }
      },
      function () {}
    );
  };

  renderSummary = (item) => {
    const parts = [
      item.Address1,
      item.City && item.City.Name,
      item.State && item.State.Name,
    ].filter((value) => value && String(value).trim());
    return parts.join(", ");
  };

  render() {
    const list = this.props.addressList || [];
    const max = this.props.max || 5;
    const canAdd = list.length < max;
    const { form } = this.state;

    return (
      <section className="profile-addresses">
        <div className="profile-addresses__header">
          <div>
            <h4 className="profile-addresses__title">
              <Translate value="address_my_addresses" />
            </h4>
            <p className="profile-addresses__hint">
              <Translate value="address_hint" /> ({list.length}/{max})
            </p>
          </div>
          <button
            type="button"
            className="profile-addresses__add"
            onClick={this.openCreate}
            disabled={!canAdd}
          >
            <FaPlus />
            <Translate value="address_add" />
          </button>
        </div>

        {list.length === 0 ? (
          <div className="profile-addresses__empty">
            <FaMapMarkerAlt />
            <p>
              <Translate value="address_empty" />
            </p>
          </div>
        ) : (
          <ul className="address-list">
            {list.map((item, index) => (
              <li className="address-list__item" key={item.Id}>
                <div className="address-list__icon">
                  <FaMapMarkerAlt />
                </div>
                <div className="address-list__info">
                  <div className="address-list__name">
                    {item.Name || `${I18n.t("address_label")} ${index + 1}`}
                    {item.IsPrimary && (
                      <span className="address-list__primary">
                        <FaStar /> <Translate value="address_primary" />
                      </span>
                    )}
                  </div>
                  <div className="address-list__summary">
                    {this.renderSummary(item) || (
                      <span className="address-list__muted">
                        <Translate value="address_incomplete" />
                      </span>
                    )}
                  </div>
                  {item.Phone ? (
                    <div className="address-list__phone">{item.Phone}</div>
                  ) : null}
                </div>
                <div className="address-list__actions">
                  <button
                    type="button"
                    className="address-list__btn address-list__btn--edit"
                    onClick={() => this.openEdit(item)}
                    aria-label={I18n.t("profile_edit")}
                  >
                    <FaPen />
                  </button>
                  <button
                    type="button"
                    className="address-list__btn address-list__btn--delete"
                    onClick={() => this.onDelete(item)}
                    aria-label={I18n.t("address_delete_title")}
                  >
                    <FaTrashAlt />
                  </button>
                </div>
              </li>
            ))}
          </ul>
        )}

        <Modal
          isOpen={this.state.modalOpen}
          onClose={this.closeModal}
          title={
            this.state.editingId ? (
              <Translate value="address_edit" />
            ) : (
              <Translate value="address_add" />
            )
          }
        >
          <div className="address-form">
            <div className="address-form__field">
              <label>
                {I18n.t("address_name")} <span className="address-form__req">*</span>
              </label>
              <input
                type="text"
                className="form-control profile-edit-input"
                placeholder={I18n.t("address_name_placeholder")}
                value={form.name}
                onChange={this.onChangeField("name")}
                maxLength={60}
              />
            </div>

            <div className="address-form__row">
              <div className="address-form__field">
                <label>
                  {I18n.t("profile_state")}{" "}
                  <span className="address-form__req">*</span>
                </label>
                <select
                  className="form-control profile-edit-input"
                  value={form.state_id}
                  onChange={this.onChangeState}
                >
                  <option value="">{I18n.t("profile_select")}</option>
                  {this.props.stateList.map((state) => (
                    <option key={state.key} value={state.key}>
                      {state.label}
                    </option>
                  ))}
                </select>
              </div>

              <div className="address-form__field">
                <label>
                  {I18n.t("profile_city")}{" "}
                  <span className="address-form__req">*</span>
                </label>
                <select
                  className="form-control profile-edit-input"
                  value={form.city_id}
                  onChange={this.onChangeField("city_id")}
                  disabled={!form.state_id}
                >
                  <option value="">{I18n.t("profile_select")}</option>
                  {this.state.cities.map((city) => (
                    <option key={city.key} value={city.key}>
                      {city.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="address-form__field">
              <label>
                {I18n.t("address_street")}{" "}
                <span className="address-form__req">*</span>
              </label>
              <input
                type="text"
                className="form-control profile-edit-input"
                placeholder={I18n.t("address_street_placeholder")}
                value={form.address1}
                onChange={this.onChangeField("address1")}
              />
            </div>

            <div className="address-form__field">
              <label>{I18n.t("address_reference")}</label>
              <input
                type="text"
                className="form-control profile-edit-input"
                placeholder={I18n.t("address_reference_placeholder")}
                value={form.address2}
                onChange={this.onChangeField("address2")}
              />
            </div>

            <div className="address-form__row">
              <div className="address-form__field">
                <label>{I18n.t("address_zipcode")}</label>
                <input
                  type="text"
                  className="form-control profile-edit-input"
                  placeholder={I18n.t("address_zipcode")}
                  value={form.zipcode}
                  onChange={this.onChangeField("zipcode")}
                  maxLength={12}
                />
              </div>

              <div className="address-form__field">
                <label>{I18n.t("profile_phone_home")}</label>
                <input
                  type="text"
                  className="form-control profile-edit-input"
                  placeholder={I18n.t("profile_phone_home")}
                  value={form.phone}
                  onChange={this.onChangeField("phone")}
                  maxLength={20}
                />
              </div>
            </div>

            <div className="address-form__footer">
              <button
                type="button"
                className="address-form__btn address-form__btn--cancel"
                onClick={this.closeModal}
              >
                <Translate value="close" />
              </button>
              <button
                type="button"
                className="address-form__btn address-form__btn--save"
                onClick={this.onSubmit}
                disabled={this.state.saving}
              >
                {this.state.saving ? "..." : I18n.t("save")}
              </button>
            </div>
          </div>
        </Modal>
      </section>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    stateList: reducer.state.list,
    addressList: reducer.address.list,
    max: reducer.address.max,
    loading: reducer.address.loading,
  };
}

const mapDispatchToProps = (dispatch) => ({
  LoadStates: (user_id, token) =>
    dispatch(actions_state.loadList({ user_id, token })),
  LoadAddresses: (user_id, token) =>
    dispatch(actions_address.loadList({ user_id, token })),
  CreateAddress: (user_id, token, params) =>
    dispatch(actions_address.newItem({ user_id, token, params })),
  UpdateAddress: (user_id, token, params) =>
    dispatch(actions_address.updateItem({ user_id, token, params })),
  RemoveAddress: (user_id, token, address_id) =>
    dispatch(actions_address.removeItem({ user_id, token, address_id })),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProfileAddresses);
